import { useState, useEffect } from 'react';

const MONTHS = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

function lastDayOfMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

// Выбор периода: месяц / год / произвольный диапазон. Отдаёт наружу { from, to } в формате YYYY-MM-DD
// (или { from: null, to: null } для «за всё время»). storageKey — опционально: если задан, выбор
// переживает уход со страницы и возврат (например, из карточки сделки обратно к списку).
export default function PeriodPicker({ onChange, storageKey }) {
  const now = new Date();
  const saved = (() => {
    if (!storageKey) return null;
    try { return JSON.parse(sessionStorage.getItem(storageKey)); } catch { return null; }
  })();
  const [mode, setMode] = useState(saved?.mode || 'all');
  const [year, setYear] = useState(saved?.year || now.getFullYear());
  const [month, setMonth] = useState(saved?.month || now.getMonth() + 1);
  const [from, setFrom] = useState(saved?.from || '');
  const [to, setTo] = useState(saved?.to || '');

  const emit = (nextMode, y, m, f, t) => {
    if (storageKey) sessionStorage.setItem(storageKey, JSON.stringify({ mode: nextMode, year: y, month: m, from: f, to: t }));
    if (nextMode === 'all') return onChange({ from: null, to: null });
    if (nextMode === 'year') return onChange({ from: `${y}-01-01`, to: `${y}-12-31` });
    if (nextMode === 'month') return onChange({ from: `${y}-${String(m).padStart(2, '0')}-01`, to: `${y}-${String(m).padStart(2, '0')}-${lastDayOfMonth(y, m)}` });
    if (nextMode === 'range') return onChange({ from: f || null, to: t || null });
  };

  // Эмитим сохранённый период при монтировании только если он реально был сохранён — иначе
  // (обычный вызов без storageKey, или первый заход без сохранённого периода) поведение не
  // меняется: родитель остаётся со своим начальным значением, пока пользователь не тронет виджет.
  useEffect(() => { if (storageKey && saved) emit(mode, year, month, from, to); }, []);

  const setModeAndEmit = (m) => { setMode(m); emit(m, year, month, from, to); };

  const years = Array.from({ length: 6 }, (_, i) => now.getFullYear() - 3 + i);

  return (
    <div className="toolbar" style={{ display: 'inline-flex', gap: 8 }}>
      <select value={mode} onChange={e => setModeAndEmit(e.target.value)} style={{ minWidth: 130 }}>
        <option value="all">За всё время</option>
        <option value="month">Месяц</option>
        <option value="year">Год</option>
        <option value="range">Период</option>
      </select>
      {mode === 'month' && (
        <>
          <select value={month} onChange={e => { const v = Number(e.target.value); setMonth(v); emit('month', year, v, from, to); }}>
            {MONTHS.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
          </select>
          <select value={year} onChange={e => { const v = Number(e.target.value); setYear(v); emit('month', v, month, from, to); }}>
            {years.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </>
      )}
      {mode === 'year' && (
        <select value={year} onChange={e => { const v = Number(e.target.value); setYear(v); emit('year', v, month, from, to); }}>
          {years.map(y => <option key={y} value={y}>{y}</option>)}
        </select>
      )}
      {mode === 'range' && (
        <>
          <input type="date" value={from} onChange={e => { setFrom(e.target.value); emit('range', year, month, e.target.value, to); }} />
          <span className="text-muted">—</span>
          <input type="date" value={to} onChange={e => { setTo(e.target.value); emit('range', year, month, from, e.target.value); }} />
        </>
      )}
    </div>
  );
}
